$(document).ready(function(){ 
    if( $('.cardsroundedimgdescr').length > 0 ) {

     
        $('.cardsroundedimgdescr_carousel').owlCarousel({
            dots: true,
            margin: 30,
            loop: true,
            responsive : {
                // breakpoint from 0 up
                0 : {
                    items: 1,
                },
                // breakpoint from 800 up
                900 : {
                    items: 2,
                },
                // breakpoint from 425 up
                1400 : {
                    nav: true,
                    navText: ["<img src='../../wp-content/themes/index/assets/images/pictos/element_arrow_left.svg'>","<img src='../../wp-content/themes/index/assets/images/pictos/element_arrow_right.svg'>"],
                    items: 3
                }
            }
        })
    }
});
 